import React, { useState, useEffect } from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const [policyTextJP, setPolicyTextJP] = useState("");
  const [policyTextEN, setPolicyTextEN] = useState("");

  // テキストファイルを取得
  useEffect(() => {
    fetch("/privacy-policy-jp.txt")
      .then((response) => response.text())
      .then((text) => setPolicyTextJP(text))
      .catch((error) => console.error("Error loading privacy policy:", error));
  }, []);

  useEffect(() => {
    fetch("/privacy-policy-en.txt")
      .then((response) => response.text())
      .then((text) => setPolicyTextEN(text))
      .catch((error) => console.error("Error loading privacy policy:", error));
  }, []);


  return (
    <div className="privacy-policy">
      <h1>個人情報保護方針 / Privacy Policy</h1>
      <pre>{policyTextJP}</pre>
      <div class="container">
        <h3>個人情報の開示等の請求について</h3>
          <div>当社は、当社が保有する個人情報（保有個人データ）について、ご本人またはその代理人からの開示等のご請求に適切に対応いたします。</div>
        <h4>１．開示等の対象</h4>
          <div>ご本人は、当社に対し、以下の請求を行うことができます。
          <ul>
            <li>利用目的の通知</li>
            <li>開示</li>
            <li>内容の訂正、追加または削除</li>
            <li>第三者提供の停止</li>
            <li>開示</li>
          </ul></div>
        <h4>２．請求方法</h4>
          <div>開示等のご請求は、下記窓口まで電話またはメールにてご連絡ください。<br></br>
          当社より所定の請求書様式を送付いたします。<br></br>
          請求書に必要事項をご記入のうえ、本人確認書類を添付し、当社指定の方法によりご返送ください。</div>
          <h4>３．本人確認について</h4>
          <div>ご請求にあたっては、ご本人であることを確認するため、以下の書類の提示または提出をお願いいたします。<br></br>
          （例）<br></br>
          <ul>
            <li>運転免許証</li>
            <li>マイナンバーカード（表面のみ）</li>
            <li>パスポート 等</li>
          </ul>
          ※本籍地等の機微情報は、あらかじめ黒塗りのうえご提出ください。</div>
        <h4>４．代理人による請求</h4>
          <div>代理人によるご請求の場合は、以下の書類をご提出いただきます。<br></br>
          <ul>
            <li>ご本人確認書類</li>
            <li>代理人の本人確認書類</li>
            <li>委任状（ご本人の署名または記名押印</li>
          </ul>
          ※未成年者の法定代理人の場合は、戸籍謄本等の関係確認書類をご提出いただく場合があります。</div>
        <h4>５．手数料</h4>
          <div>開示および利用目的の通知に関するご請求については、原則として無料といたします。<br></br>
          ただし、郵送等にかかる実費をご負担いただく場合があります。</div>
        <h4>６．回答方法および回答期間</h4>
          <div>ご請求内容を確認のうえ、合理的な期間内（原則として2週間以内）に、書面または電磁的方法により回答いたします。</div>
        <h4>７．開示等に応じられない場合</h4>
          <div>以下の場合には、開示等のご請求に応じられないことがあります。<br></br>
          その場合は、理由を付してご通知いたします。
          <ul>
            <li>ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
            <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
            <li>法令に違反することとなる場合</li>
          </ul></div>
        <h4>８．個人情報に関するお問い合わせ窓口</h4>
          <div>株式会社 IT plus<br></br>
          個人情報相談窓口<br></br>
          TEL：052-684-5742<br></br>
          メール：security@i-t-plus.co.jp<br></br>
          受付時間：平日 9:00～18:00（※土日祝日、年末年始を除く）</div>
      </div>
      <pre>{policyTextEN}</pre>
    </div>
    
  );
};

export default PrivacyPolicy;
